<template>
  <div>
    <report-panel :anchor="''">
      <div slot="title">Previous Names</div>
      <div slot="body">
        <!-- panel content start -->
        <table class="table table-striped" id="previous-names-table">
          <tbody>
            <tr v-if="report.companyoverview.registerednames.length === '0'">
              <td colspan="3">No previous names found</td>
            </tr>
            <tr v-if="report.companyoverview.registerednames.length !== '0'">
              <th scope="row">Name:</th>
              <th scope="row">From:</th>
              <th scope="row">To:</th>
            </tr>
            <tr v-for="name in report.companyoverview.registerednames" :key="name.id">
              <td>{{ isEmptyMessage(name.name) }}</td>
              <td>{{ isEmptyMessage(formatDate(name.start_date)) }}</td>
              <td>{{ isEmptyMessage(formatDate(name.end_date)) }}</td>
            </tr>
          </tbody>
        </table>
        <!-- panel content end -->
      </div>
    </report-panel>
  </div>
</template>

<script>
import toolsMixin from '@/components/reports/ToolsMixin';
import ReportPanel from '@/components/reports/components/ReportPanel';

export default {
  components: {
    ReportPanel,
  },
  mixins: [toolsMixin],
  props: ['report'],
};
</script>
